module.exports = __webpack_public_path__ + "img/lv5.fc13bdad.png";